import React from 'react'

import { getObjectLabels } from '@paintscout/util/builder'
import type { Theme } from '@material-ui/core'
import { makeStyles } from '@material-ui/core'
import Typography from '@paintscout/ui/components/Typography'
import type { DropdownSelectOption, SingleSelectProps } from '../DropdownSelect'
import DropdownSelect from '../DropdownSelect'
import { useClientOptions } from '../../providers/ClientOptionsProvider'

const useStyles = makeStyles<Theme, CoatsSelectorProps>((theme) => ({
  selected: {
    color: ({ disabled }) => (disabled ? theme.paintscout.palette.brand.Neutral.P80 : theme.palette.text.primary)
  }
}))

export interface CoatsSelectorProps extends Omit<SingleSelectProps, 'variant' | 'value' | 'options' | 'onChange'> {
  value?: number
  label?: string
  possibleValues?: number[]
  rateLabel?: string
  disabled?: boolean
  showRates?: boolean
  onChange?: (value: number) => void
}

export default function CoatsSelector({
  value,
  possibleValues = [],
  onChange,
  showRates = true,
  label = 'Coats',
  rateLabel,
  ...props
}: CoatsSelectorProps) {
  const classes = useStyles(props)
  const { options } = useClientOptions()
  const { application } = getObjectLabels({ options })

  const dropdownOptions: DropdownSelectOption[] = possibleValues.map((item, index) => {
    const rateLabelStr = rateLabel ? ` (${item} ${rateLabel})` : ''
    const unitLabel = showRates ? ` ${application.plural}${rateLabelStr}` : ''
    return {
      label: `${index + 1}${unitLabel}`,
      value: item?.toString() ?? ''
    }
  })

  return (
    <DropdownSelect
      {...props}
      label={label}
      variant="single"
      value={dropdownOptions[value - 1]}
      options={dropdownOptions}
      onChange={(option) => onChange(dropdownOptions.indexOf(option) + 1)}
      hideIcon={props.disabled}
      formatOptionLabel={(option, placement) => {
        if (placement === 'selected') {
          return <Typography className={classes.selected}>{value}</Typography>
        } else {
          return <Typography>{option.label}</Typography>
        }
      }}
    />
  )
}
